const state = {
  isFromEquipment: false,
  assetSystemLevels: {},
  equipmentFunctions: [],
  outputs: []
};
const getters = {
  isFromEquipment: state => state.isFromEquipment,
  getAssetSystemLvlObj: state => state.assetSystemLevels,
  equipmentFunctionsGetter: state => state.equipmentFunctions,
  allOutputsGetter: state => state.outputs
};
const actions = {
};
const mutations = {
  setEquipmentStatus(state, bool) {
    state.isFromEquipment = bool
  },
  setAssetSystemLevels(state, obj) {
    state.assetSystemLevels = obj
  },
  setEquipmentFunctions(state, arr) {
    state.equipmentFunctions = arr
  },
  setOutputs(state, arr) {
    state.outputs = arr
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};